<template>
    <v-flex fill-height>
        <sidemainmenu/>
        <br />
        <v-progress-linear color="red" slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
        </v-alert>
        <v-alert :value="alerterror" color="error" icon="new_releases">
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </v-alert>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <h3 class="py-4">Gate IN Pending</h3>
                        <export-excel
                            title = "VCFS Import Gate In Pending"
                            :data   = "gateinpending_details">
                            <v-btn color="cyan">
                                <v-icon color="white">file_copy</v-icon>
                            </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="gateinpending_details" :search="search" class="elevation-1" :rows-per-page-items="[100, 500, 1000, 5000]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td class="text-xs-right">{{ props.item.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.igm_date }}</td>
                            <td class="text-xs-right">{{ props.item.bl_no }}</td>
                            <td class="text-xs-right">{{ props.item.bl_date }}</td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.sizetype }}</td>
                            <td class="text-xs-right">{{ props.item.vessel }}</td>
                            <td class="text-xs-right">{{ props.item.voyage }}</td>
                            <td class="text-xs-right">{{ props.item.berthed_on }}</td>
                            <td class="text-xs-right">{{ props.item.cargo_description }}</td>
                            <td class="text-xs-right">{{ props.item.packages }}</td>
                            <td class="text-xs-right">{{ props.item.package_unit }}</td>
                            <td class="text-xs-right">{{ props.item.file_no }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus/>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import DatetimePicker from 'vuetify-datetime-picker';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'gateinpending',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            gateinpending_details: [],
            activeVal: "Open",
            loading: false,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', sorting: false, align: 'left' },
              { text: 'IGM No', align: 'right', value: 'igm_no' },
              { text: 'IGM Date', align: 'right', value: 'igm_date' },
              { text: 'BL No', align: 'right', value: 'bl_no' },
              { text: 'BL Date', align: 'right', value: 'bl_date' },
              { text: 'Container No.', align: 'right', value: 'cont_no' },
              { text: 'Size Type', align: 'right', value: 'sizetype' },
              { text: 'Vessel', align: 'right', value: 'vessel' },
              { text: 'Voyage', align: 'right', value: 'voyage' },
              { text: 'Berthed on', align: 'right', value: 'berthed_on' },
              { text: 'Cargo', align: 'right', value: 'cargo_description' },
              { text: 'package', align: 'right', value: 'packages' },
              { text: 'Unit', align: 'right', value: 'package_unit' },
              { text: 'Work Order', align: 'right', value: 'file_no' }
            ]
        }
    },
    mounted:function(){
        this.getData()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            this.API_URL = this.$hostname + "/reports/gateinpending"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.gateinpending_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = error.response.data.result;
                alert(this.error);
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay 
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center
      
</style>
